import { render, staticRenderFns } from "./GroupPermission.vue?vue&type=template&id=d98975c6&scoped=true&"
import script from "./GroupPermission.vue?vue&type=script&lang=js&"
export * from "./GroupPermission.vue?vue&type=script&lang=js&"
import style0 from "./GroupPermission.vue?vue&type=style&index=0&id=d98975c6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d98975c6",
  null
  
)

export default component.exports